export enum IdpRoleEnum {
    Admin = "Admin",
    User = "User"
}